module.exports = __webpack_public_path__ + "img/homesol_1.523e223e.png";